// extracted by mini-css-extract-plugin
export default {"responsive":"SplitByIdModal_responsive_cNJln"};